<template>
    <div>
      <MainStatue pgeTitle='Contact' v-bind:msg="message"/>
      <section id='contact'>
        <div class='container'>
          <div class='row'>
            <div class='col-md-12'>
              <div class='contact-form'>
                <h1 v-show="successfulSubmit">Thank You!</h1>
                <form v-show="!successfulSubmit" id='contact-form' method='POST' action='https://script.google.com/macros/s/AKfycbwONCz1r-3cGJzt8qGN2AMbJ6BXBn88R1mYHOjc/exec'>
                  <input name='name' type='text' class='form-control' placeholder='Your Name' required>
                  <input name='email' id='email-invalid' type='email' class='form-control' placeholder='Your Email' required>
                  <textarea name='message' class='form-control' placeholder='Message' rows='4' required></textarea>
                  <div class='contact-submit'>
                    <input type='submit'  class='form-control submit' value='Send a message'>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      <BottomSection />
    </div>
</template>
<script>
import MainStatue from '@/components/MainStatue.vue';
import BottomSection from '@/components/BottomSection.vue';

export default {
  name: 'ContactForm',
  components: {
    MainStatue,
    BottomSection,
  },
  data() {
    return {
      successfulSubmit: false,
      message: `I'D LOVE TO HEAR FROM YOU!`,
    };
  },
  methods: {
    validEmail(email) { // see:
        const re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
        return re.test(email);
    },
    getFormData() {
        const form = document.getElementById('contact-form');
        const elements = form.elements;

        const fields = Object.keys(elements).filter((k) => {
            return (elements[k].name !== 'honeypot');
        }).map((k) => {
            if (elements[k].name !== undefined) {
                return elements[k].name;
                // special case for Edge's html collection
            } else if (elements[k].length > 0) {
                return elements[k].item(0).name;
            }
        }).filter((item, pos, self) => {
            return self.indexOf(item) === pos && item;
        });

        const formData = {};
        fields.forEach((name) => {
            const element = elements[name];
            formData[name] = element.value;

            if (element.length) {
                const data = [];
                for (const i = 0; i < element.length; i++) {
                  const item = element.item(i);
                  if (item.checked || item.selected) {
                    data.push(item.value);
                  }
                }
                formData[name] = data.join(', ');
            }
        });
        formData.formDataNameOrder = JSON.stringify(fields);
        formData.formGoogleSheetName = form.dataset.sheet || 'responses';
        formData.formGoogleSendEmail = form.dataset.email || '';
        return formData;
    },
    handleFormSubmit(event) {
        event.preventDefault();
        const data = this.getFormData();

        if (data.email && !this.validEmail(data.email)) {
          const invalidEmail = document.getElementById('email-invalid');
          if (invalidEmail) {
            invalidEmail.style.display = 'block';
            return alert('Please enter a valid email so I can respond back!');
          }
        } else {
            const url = event.target.action;
            const xhr = new XMLHttpRequest();
            xhr.open('POST', url);
            xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
            xhr.onreadystatechange = () => {
              this.successfulSubmit = true;
              this.message = 'Your message has been sent!';
              return;
            };

            const encoded = Object.keys(data).map((k) => {
              return encodeURIComponent(k) + '=' + encodeURIComponent(data[k]);
            }).join('&');
            xhr.send(encoded);
        }
    },
  },
  mounted() {
    const form = document.getElementById('contact-form');
    form.addEventListener('submit', this.handleFormSubmit, false);
  },
};
</script>
<style scoped>
h1 {
  color: white;
  transform: translateY(-400px);
}
#contact {
 background-color: #091341;

}

#contact-form {
   transform: translateY(-400px);
   max-height: 500px;
}

.contact-form {
  display: flex;
  align-items: center;
  flex-direction: column;
}

#contact .form-control {
  border: 1px solid #eee;
  border-radius: 0px;
  box-shadow: none;
  font-size: 16px;
  margin-bottom: 16px;
  transition: all 0.4s ease-in-out;
}

#contact .form-control:hover {
  border-color: #f0f0f0;
}

#contact textarea {
  min-height: 100px;
}

#contact input {
  height: 50px;
  min-width: 500px;
}

#contact input[type='submit'] {
  background: #111112;
  color: #ffffff;
  font-size: 15px;
  font-weight: 400;
  letter-spacing: 2px;
  transition: all 0.4s ease-in-out;
  margin-top: 10px;
}

#contact input[type='submit']:hover {
  background: #444;
}
</style>